import EditorView from './Editor'
export default EditorView
